<template>
  <div>
    <!--    :trainerName="hello"-->
    <workshop-banner
      :workshopName="WorkshopData.name"
      :timestamp="WorkshopData.workshop_ts"
      :duration="WorkshopData.duration"
      :cls="classes"
    ></workshop-banner>
    <modal name="invoice" :adaptive="true" width="100%" height="100%">
      <invoice
        :items="[
          {
            description: WorkshopData.name,
            quantity: 1,
            price: WorkshopData.fee,
          },
        ]"
        :pid="WorkshopData.id"
      ></invoice>
    </modal>
    <modal name="welcome" width="66%" height="auto">
      <u-pane></u-pane>
    </modal>
    <div class="container updated_container">
      <div class="content_wrapper">
        <div class="side-wrapper">
          <div class="workshop_info">
            <u-live-icon v-if="isLive"></u-live-icon>
            <img
              :src="
                `${WorkshopData}` &&
                  `${WorkshopData.image}` &&
                  `https://backend.upskill.com.bd${WorkshopData.image}`
              "
              alt
              class="img-fluid wrk-img"
            />
            <div class="course_action">
              <div class="course_action" v-if="WorkshopData.status == 1">
                <u-btn-a color="white" textColor="black">Unlisted</u-btn-a>
              </div>
              <div class="course_action" v-else>
                <div class="course_price" v-if="!hasDiscount">
                  <h2>
                    {{
                      WorkshopData && WorkshopData.fee === 0
                        ? 'Free'
                        : `Tk.${WorkshopData.fee}`
                    }}
                  </h2>
                  <p>
                    {{
                      WorkshopData && WorkshopData.workshop_ts && getTimeLeft
                    }}
                  </p>
                </div>
                <div class="course_price" v-else>
                  <div style="display:flex; align-content: center">
                    <h3
                      style="text-decoration: line-through; color:#555D50; font-family: Montserrat, sans-serif;"
                      class="pr-3"
                    >
                      {{
                        WorkshopData && WorkshopData.fee === 0
                          ? 'Free'
                          : `Tk.${WorkshopData.fee}`
                      }}
                    </h3>
                    <h2>Tk.{{ WorkshopData.fee - discountedPrice }}</h2>
                  </div>
                  <div
                    style="background-color: indianred; color: white; width: 100px; text-align: center; font-weight: bold"
                    class="mb-2"
                  >
                    {{ parseInt((discountedPrice / WorkshopData.fee) * 100) }}%
                    Off
                  </div>
                  <p>
                    {{
                      WorkshopData && WorkshopData.workshop_ts && getTimeLeft
                    }}
                  </p>
                </div>
                <div class="blue-txt">
                  Link will be sent to your mail before the session.
                </div>
                <!--                <div class="mt-2" style="font-size: 18px;color: #538fcd;">-->
                <!--                  (10% Discount on Online Payment)-->
                <!--                </div>-->
                <u-btn-a
                  @click.prevent.native=""
                  :loading="loading"
                  color="gray"
                  textColor="white"
                  v-if="isOver"
                  >Workshop Ended</u-btn-a
                >
                <u-btn-a
                  @click.prevent.native="register"
                  :loading="loading"
                  v-if="status === 'Error' && !isOver && SignedIn"
                  >Register Now</u-btn-a
                >
                <u-btn-a
                  @click.prevent.native="registerNewUser"
                  :loading="loading"
                  v-if="!SignedIn() && !isOver"
                  >Register Now</u-btn-a
                >
                <u-btn-a
                  v-if="canShowBkash"
                  @click.prevent.native="pay"
                  :loading="bkashLoading"
                  color="white"
                  textColor="black"
                  >Pay with
                  <img
                    src="../../assets/images/bkash.png"
                    style="max-width: 80px"
                  />
                </u-btn-a>
                <u-btn-a v-if="isPaid" color="white" textColor="green"
                  >PAID
                </u-btn-a>
                <!--            <u-btn-a-->
                <!--              @click.prevent.native="cancel"-->
                <!--              :loading="loading"-->
                <!--              color="red"-->
                <!--              textColor="white"-->
                <!--              v-if="status === 'Success' && !isOver && SignedIn && !isPaid"-->
                <!--              >Cancel</u-btn-a-->
                <!--            >-->
                <u-btn-a
                  @click.prevent.native="payOnline"
                  :loading="loading"
                  v-if="
                    status === 'Success' &&
                      !isOver &&
                      SignedIn &&
                      !isPaid &&
                      WorkshopData.fee > 0
                  "
                  >Pay Online</u-btn-a
                >
              </div>
            </div>
            <nav class="WizardSteps mt-3 mb-1" v-if="!isOver">
              <a class="WizardSteps__step WizardSteps__step--complete">
                <span class="WizardSteps__status">
                  <span class="WizardSteps__status-text">1</span>
                </span>

                <h4 class="WizardSteps__title">Register</h4>
              </a>

              <a
                v-if="WorkshopData.fee > 0"
                class="WizardSteps__step"
                :class="{
                  'WizardSteps__step--complete':
                    status === 'Success' &&
                    !isOver &&
                    SignedIn &&
                    !isPaid &&
                    WorkshopData.fee > 0,
                  'WizardSteps__step--error':
                    status === 'Success' &&
                    !(!isOver && SignedIn && !isPaid && WorkshopData.fee > 0),
                }"
              >
                <span class="WizardSteps__status">
                  <span class="WizardSteps__status-text">2</span>
                </span>

                <h4 class="WizardSteps__title">Payment Pending</h4>
              </a>
              <a
                v-if="WorkshopData.fee > 0"
                class="WizardSteps__step"
                :class="{
                  'WizardSteps__step--complete':
                    isPaid || (free_course && status === 'Success'),
                  'WizardSteps__step--error': !isPaid && free_course,
                }"
              >
                <span class="WizardSteps__status">
                  <span
                    class="WizardSteps__status-text"
                    v-if="isPaid || (free_course && status === 'Success')"
                    >&check;</span
                  >
                  <span class="WizardSteps__status-text" v-else>3</span>
                </span>

                <h4 class="WizardSteps__title">Seat Confirmed</h4>
              </a>
              <a
                v-else
                class="WizardSteps__step"
                :class="{
                  'WizardSteps__step--complete': status === 'Success',
                }"
              >
                <span class="WizardSteps__status">
                  <span class="WizardSteps__status-text">2</span>
                </span>

                <h4 class="WizardSteps__title">Seat Confirmed</h4>
              </a>
            </nav>
            <div class="separator1"></div>

            <div class="modal">
              <iframe
                id="bKashFrame"
                @transactionSuccess="payConfirm"
                scrolling="no"
                frameborder="0"
              >
                Your browser doesn't support iframes
              </iframe>
            </div>
            <div class="side-info">
              <h4 class="side-info-header">This course includes</h4>
              <ul class="side-list">
                <li>
                  <i class="fa fa-video-camera fa-lg"></i> On demand video
                </li>
                <li>
                  <i class="fa fa-cloud-download fa-lg"></i> Downloadable
                  resources
                </li>
                <li><i class="fa fa-unlock fa-lg"></i> Full lifetime access</li>
                <li>
                  <i class="fa fa-mobile fa-lg"></i> Access on mobile and
                  computer
                </li>

                <li>
                  <i v-show="!free_course" class="fa fa-certificate fa-lg"></i>

                  {{
                    WorkshopData && WorkshopData.fee === 0
                      ? ' '
                      : `Certificate of completion`
                  }}
                </li>
                <li style="font-size: 16px;  color: grey;">
                  <i class="fa fa-phone fa-lg mr-2 mt-2"></i>
                  <a href="tel:+8801714053213" style="color: grey;"
                    >01714053213</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- <workshoptrainerBio></workshoptrainerBio> -->
        </div>
        <div class="workshop_desc">
          <div class="cb-tab">
            <ul class="tab-header">
              <li class="active tabs-h" data-target="#tab-one">
                Course Outline
              </li>
              <li class="tabs-h" data-target="#tab-two">Description</li>
            </ul>
            <div id="tab-one" class="tab-content active">
              <div
                class="wrk-content"
                v-html="RemoveStyle(WorkshopData.course_outline)"
              ></div>
            </div>

            <div id="tab-two" class="tab-content">
              <div
                class="wrk-content"
                v-html="RemoveStyle(WorkshopData && WorkshopData.description)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- tab -->
    </div>
  </div>
</template>

<script>
import invoice from '../invoice'
import workshopBanner from './workshopBanner'
//import workshoptrainerBio from "./workshoptrainerBio";
import { mapGetters, mapActions } from 'vuex'
var moment = require('moment')
export default {
  components: {
    invoice,
    workshopBanner,
    //workshoptrainerBio
  },
  data() {
    return {
      isPaid: false,
      msgListener: '',
      isLive: false,
      status: '',
      loading: false,
      WorkshopData: [],
      hasDiscount: false,
      discountedPrice: 0,
      bkashLoading: false,
      isBkashProfile: false,
      invoiceModal: true,
      classes: [],
      c_test: [],
      wrk_id: '',
      free_course: false,
      registeredAlready: false,
    }
  },
  props: [
    'workshopId',
    'workshopName',
    'trainerName',
    'timestamp',
    'duration',
    'cls',
  ],
  computed: {
    ...mapGetters('WorkshopData', ['getWorkshopById']),
    getTime() {
      return moment(this.WorkshopData.workshop_ts).format(
        'LT ddd, DD MMMM, YYYY'
      )
    },
    canShowBkash() {
      return this.isBkashProfile && !this.isPaid
    },
    getTimeLeft() {
      // console.log(moment().unix());
      // console.log(moment(this.HomeUWS.workshop_ts).unix() - moment().unix());
      if (moment(this.WorkshopData.workshop_ts).unix() - moment().unix() > 0) {
        return (
          moment(this.WorkshopData.workshop_ts).fromNow() + ' left'
        ).replace('in', '')
      } else {
        return 'registration over'
      }
    },
    isOver() {
      return moment(this.WorkshopData.workshop_ts).unix() - moment().unix() <= 0
    },
  },
  methods: {
    ...mapActions('WorkshopData', ['GET_WORKSHOPDATA_BY_ID']),
    getDuration(data) {
      return data < 1 ? data * 100 + ' Minute(s)' : data + ' Hour(s)'
    },
    payOnline() {
      this.$modal.show('invoice')
      // console.log(this.$route.params)
      // this.$router.push({name:"invoice", query:{wid: this.$route.params.workshopId}})
    },
    registerNewUser() {
      this.LocalStore('pendingWorkshop', this.WorkshopData.id)
      localStorage.setItem('pendingWorkshop', this.WorkshopData.id)
      this.Goto({ name: 'login' })
    },
    register() {
      this.loading = true
      this.$upskill
        .join(this.WorkshopData.id)
        .then(() => {
          this.loading = false
          this.SuccessAlert(
            'Registered! Please complete the purchase by clicking the pay button'
          )
          // this.SuccessAlert(res.data.Success);
          // this.Goto({ name: "thanks" });
          if (this.PendingFirstTimer()) {
            // this.$modal.show("welcome")
            this.RemoveFirstTimer()
          }
          this.checkStatus()
        })
        .catch((err) => {
          this.loading = false
          this.ErrorAlert(err.data.Error)
        })
    },
    cancel() {
      this.loading = true
      this.$upskill
        .cancel(this.WorkshopData.id)
        .then((res) => {
          this.loading = false
          this.SuccessAlert(res.data.Success)
          this.checkStatus()
          this.Loaded()
        })
        .catch((err) => {
          this.loading = false
          this.ErrorAlert(err.data.Error)
          this.Loaded()
        })
    },
    checkStatus() {
      // registered or not
      this.$upskill.status(this.WorkshopData.id).then((res) => {
        this.status = res.data.status
      })
      this.$upskill.userProfileStatus().then((res) => {
        let list = res.data.data
        let found = list.find((w) => w.wid == this.workshopId)
        // if (found && !found.bools.paid) {
        if (found && found.bools.paid) {
          this.isPaid = found.bools.paid
        } else {
          this.$upskill
            .workshopPurchaseStatus(this.WorkshopData.id)
            .then((res) => {
              this.isPaid = res.data.status
            })
        }
      })
      // online purchase status
    },
    checkDiscount() {
      this.$upskill
        .discountByWid(this.workshopId)
        .then((res) => {
          this.discountedPrice = res.data.data.Discount
          this.hasDiscount = true
        })
        .catch(() => {
          this.hasDiscount = false
        })
    },
    pay() {
      this.bkashLoading = true
      let d = document.getElementsByClassName('modal')
      d[0].classList.add('open')
      this.$upskill.userProfilePay(this.workshopId).then((res) => {
        var frame = document.getElementById('bKashFrame')
        frame =
          frame.contentWindow ||
          frame.contentDocument.document ||
          frame.contentDocument
        frame.document.open()
        frame.document.write(res.data)
        frame.document.close()
        // this.bkashLoading = false;
        this.stepCount++
      })
    },
    checkTransaction() {
      let pending = window.localStorage.getItem('pendingTransaction')
      if (pending) {
        this.$upskill
          .validatePurchase(pending)
          .then((res) => {
            if (res.data.status == 'ACCEPTED') {
              this.SuccessAlert('Payment Complete!')
              this.isPaid = true
              this.access = true
              this.timedPayment()
              window.localStorage.removeItem('pendingTransaction')
            } else {
              this.ErrorAlert(
                'Payment failed. Could not complete the purchase!'
              )
            }
            window.localStorage.removeItem('pendingTransaction')
          })
          .catch(() => {
            this.ErrorAlert('Payment failed. Could not complete the purchase!')
            window.localStorage.removeItem('pendingTransaction')
          })
      }
    },
    payConfirm() {
      this.SuccessAlert('Payment complete!')
    },
    timedPayment() {
      this.TimerAlert('Payment Complete!', '', 1000)
      this.access = true
      this.$modal.show('welcome')
    },
  },
  async mounted() {
    // Check whether a payment request has been initiated
    this.checkTransaction()
    if (!this.getWorkshopById(this.workshopId)) {
      await this.GET_WORKSHOPDATA_BY_ID(this.workshopId)
      this.checkDiscount()
      this.Loaded()
    }
    this.WorkshopData = this.getWorkshopById(this.workshopId)
    if (this.WorkshopData.category.includes('live')) {
      this.isLive = true
    }
    if (this.WorkshopData && this.WorkshopData.fee === 0) {
      this.free_course = true
    }
    this.Loaded()
    this.checkStatus()
    //console.log(this.WorkshopData);
    // const response = await fetch(
    //   `https://be.upskill.com.bd/api/classes/${this.WorkshopData.id}`
    // );
    // const data1 = await response.json();
    // this.classes = data1.data;
  },
}
</script>

<style>
/* * {
  background: #000 !important;
  color: #0f0 !important;
  outline: solid #f00 1px !important;
} */
.container {
  max-width: 1300px !important;
}
.content_wrapper {
  flex-direction: row-reverse;
}
.wrk-img {
  border-radius: 8px 8px 0 0 !important;
}
.workshop_info {
  margin-top: -25rem;
  margin-right: 0;
  width: 400px;
  border-radius: 10px !important;
  background-color: white;
}
.course_action h2 {
  font-weight: bold;
}
.course_action {
  flex-direction: column;
  background-color: transparent;
  padding: 1em;
}
.course_action .action_button a {
  background-color: #60d91a;
  color: white;
  padding: 1em;
  letter-spacing: 0;
  width: 100%;
}
.side-info {
  padding: 1em;
}
.blue-txt {
  color: #0062ff;
  font-weight: bold;
}
.tabs-h {
  font-family: 'Montserrat', sans-serif;
}
.wrk-content {
  font-family: 'Open Sans', sans-serif;
}
.wrk-content ul li p {
  font-size: 66px;
}
.cb-tab ul li {
  text-transform: none !important;
}
iframe {
  /*height:100%;*/
  position: absolute;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 999999;
  /*min-height: 800px;*/
  height: 100%;
  width: 100%;
  /*position: absolute;*/
}
.modal {
  display: none;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
.modal.open {
  display: block;
}
.separator1 {
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid black;
}
/* .WizardSteps__line {
  flex-grow: 1;
  display: block;
  width: 100%;
  height: 1px;
  margin: 0;
  padding: 0;
  border: 0 none transparent;
  font-size: 1rem;
  background-color: #687d93;
} */

.WizardSteps__status {
  box-sizing: border-box;
  display: block;
  width: 1.5em;
  height: 1.5em;
  border: 1px solid #687d93;
  border-radius: 50%;
  line-height: calc(1.5em - 1px * 2);
  text-align: center;
}

.WizardSteps__status-text {
  color: #687d93;
}

.WizardSteps__title {
  margin: 0;
  white-space: nowrap;
  font-weight: 300;
  font-size: 1.35em;
  color: #687d93;
}

.WizardSteps__step {
  display: flex;
  flex-grow: 2;
  flex-wrap: nowrap;
  padding: 1em;
}

.WizardSteps__step > .WizardSteps__status {
  margin-right: 0.25em;
}

/* .WizardSteps > .WizardSteps__line {
  margin-left: 0.4em;
  margin-right: 0.4em;
} */

.WizardSteps {
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 100%;
}

/* Statuses */

/* Error status styles */
.WizardSteps__step--error > .WizardSteps__title {
  color: #6b6b6b;
}

.WizardSteps__step--error > .WizardSteps__status {
  border-color: #6b6b6b;
}

.WizardSteps__step--error > .WizardSteps__status > .WizardSteps__status-text {
  color: #6b6b6b;
}

/* .WizardSteps__step--error + .WizardSteps__line {
  background-color: #6B6B6B;
} */

/* Complete status styles */
.WizardSteps__step--complete > .WizardSteps__title {
  color: #000000;
  font-weight: 400;
}
.WizardSteps__step--complete > .WizardSteps__status {
  background-color: #60d91a;
}

.WizardSteps__step--complete > .WizardSteps__status {
  border-color: transparent;
}

.WizardSteps__step--complete
  > .WizardSteps__status
  > .WizardSteps__status-text {
  color: #ffffff;
}

/* .WizardSteps__step--complete + .WizardSteps__line {
  background-color: #000000;
} */

/* Active status styles */
.WizardSteps__step--active > .WizardSteps__title {
  font-weight: 400;
}

.WizardSteps__step--active > .WizardSteps__status {
  border-width: 2px;
  line-height: calc(1.5em - 2px * 2);
}

.WizardSteps__step--active > .WizardSteps__status > .WizardSteps__status-text {
  font-weight: 700;
}

.WizardSteps__step--active + .WizardSteps__line {
  height: 2px;
}
hr {
  visibility: hidden;
}
.side-list li {
  list-style: none;
  padding: 0.5em;
}
/**
 * Reset and contextual styles.
 */
html {
  height: 100%;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
}

.wrk-section {
  box-sizing: border-box;
  height: 100%;
  margin: 0;
  padding: 1.5em;
}
.cb-tab .tab-header li {
  font: 700 1.125rem/1.688rem 'Open Sans';
}

@media (max-width: 600px) {
  .workshop_info {
    margin: 0;
    /* padding: 1em; */
    width: 100%;
  }
  .wrk-img {
    width: 100%;
    height: auto;
  }
  .content_wrapper {
    overflow: hidden;
    margin-top: -120px;
    width: 100%;
  }
  .course_action {
    padding: 0.5em;
  }
  .course_action .action_button a {
    width: 250px;
    padding: 1em;
    margin: 0 auto;
  }
  .cb-tab .tab-header li {
    font-size: 16px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .workshop_info {
    margin-top: 0;
    width: 250px;
  }
  .wrk-img {
    width: 100%;
    height: auto;
    border-radius: 0 !important;
  }
  .side-info-header {
    font-size: 18px;
  }
  .course_action .action_button a {
    width: 200px !important;
  }
}
</style>
